import styled from "styled-components";

export const StyledFooter = styled.footer`
  background-color: ${({ theme }) => theme.colors.footer};
  color: #fff;
  padding: 100px 20px 60px;
  ul {
    list-style-type: none;
  }
  ul li {
    margin-bottom: 20px;
    font-family: mmc-regular;
  }
  p {
    text-align: right;
    font-family: mmc-regular;
  }
  ul li a {
    text-decoration: none;
    color: white;
    font-family: mmc-regular;
  }
  ul li a:hover {
    color: red;
  }
  img {
    width: 30%;
  }

  @media (max-width: ${({ theme }) => theme.mobile}) {
    text-align: center;
    ul {
      padding: 0;
    }
    p {
      text-align: center;
    }
    img {
      width: 90%;
    }
  }
`;
